import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import SimplePageTemplate from '@spotahome/landings-common/src/components/SimplePageTemplate';

import Error from './Error';

const StaticPage = props => (
  <SimplePageTemplate
    title={props.data.title || trans('error_page.client_error.title')}
  >
    {props.data.content ? (
      <div dangerouslySetInnerHTML={{ __html: props.data.content }} />
    ) : (
      <Error />
    )}
  </SimplePageTemplate>
);

StaticPage.propTypes = {
  data: PropTypes.object.isRequired
};

export default StaticPage;
